<template>
  <v-container
    ref="sectionRoot"
    class="nosotros-container py-9"
    :class="{ 'is-visible': visible }"
  >
    <v-row class="fade-slide-down">
      <v-col cols="12" md="10" lg="8" class="mx-auto text-center">
        <div class="section-badge mb-3">
          <span class="section-badge__dot"></span>
          Nosotros
        </div>

        <h2 class="header-title">
          Quiénes somos
        </h2>
      </v-col>
    </v-row>

    <v-row class="fade-slide-down">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <v-card flat class="nosotros-card">
          <!-- Las pestañas se emparejan por POSICIÓN con los v-window-item de
               abajo (sin :value en ninguno de los dos): la 1a pestaña siempre
               muestra el 1er window-item, la 2a el 2do, etc. Así no se puede
               volver a desalinear un tab con el contenido de otro. -->
          <v-tabs v-model="tab" color="#1B4F8C" centered grow class="tab-titles">
            <v-tab>Misión</v-tab>
            <v-tab>Visión</v-tab>
            <v-tab>Historia</v-tab>
          </v-tabs>

          <v-window v-model="tab" class="pa-6">
            <!-- Misión -->
            <v-window-item>
              <p class="text-body-1 text--secondary mision-quote">
                "Generar Servicios integrales de protección de salud para nuestros clientes
                con innovación y creatividad; con la mejor relación calidad, costo-beneficio, a través de la excelencia,
                efectividad y desarrollo de nuestros colaboradores; buscando hacer socios de negocios a nuestros principales
                proveedores, creando valor para los accionistas y promoviendo una cultura preventiva en la sociedad en
                general"
              </p>
            </v-window-item>

            <!-- Visión -->
            <v-window-item>
              <p class="text-body-1 text--secondary mb-4">
                Ser la mejor opción del mercado en servicios de acceso y protección a la salud.
              </p>
              <ul class="no-bullets pl-4">
                <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Trabajo en equipo</li>
                <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Cultura emprendedora</li>
                <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Confiabilidad</li>
                <li><v-icon color="success" small class="mr-2">mdi-check</v-icon>Compromiso</li>
              </ul>
            </v-window-item>

            <!-- Historia -->
            <v-window-item>
              <v-timeline dense>
                <v-timeline-item color="#1B4F8C" fill-dot>
                  <div class="timeline-year">2006</div>
                  <div>
                    Inicio de operaciones con el servicio de <strong>CONSULTA EXTERNA</strong> con médicos especialistas. Se
                    establece la
                    primera RED de
                    prestadores MEDICOVER®.
                  </div>
                </v-timeline-item>

                <v-timeline-item color="#1B4F8C" fill-dot>
                  <div class="timeline-year">2008</div>
                  <div>
                    Se ve la necesidad de iniciar una Alianza Estratégica con proveedores hospitalarios a efecto de que se
                    brinde a los usuarios los servicios de atención médica de <strong>URGENCIA</strong> por la pérdida de la
                    salud a causa de una ENFERMEDAD o ACCIDENTE y cuya resolución se de en un lapso menor a las 24 horas.
                  </div>
                </v-timeline-item>

                <v-timeline-item color="#1B4F8C" fill-dot>
                  <div class="timeline-year">2010</div>
                  <div>
                    Se incorpora la cobertura <strong>DENTAL</strong> mediante una red de especialistas en ortodoncia,
                    endodoncia,
                    odontopediatría,
                    cirugía ortognática y maxilofacial.
                  </div>
                </v-timeline-item>

                <v-timeline-item color="#1B4F8C" fill-dot>
                  <div class="timeline-year">2011</div>
                  <div>
                    Lanzamiento de servicios <strong>VISUALES</strong> con lentes y exámenes oftalmológicos a precios
                    preferentes.
                  </div>
                </v-timeline-item>

                <v-timeline-item color="#1B4F8C" fill-dot>
                  <div class="timeline-year">Actualidad</div>
                  <div>
                    Se continúa innovando con servicios como <strong>"Farmacia a tu casa"</strong>, descuentos en estudios
                    de laboratorio,
                    imagenología y
                    hospitalización. <br /><small>Cabe señalar que durante éstos años de servicio, se han blindado nuestras
                      membresías MEDICOVER® con
                      descuentos en Estudios de Laboratorio e Imagenología, y tarifas preferentes en caso de que nuestros
                      usuarios
                      necesiten hospitalizarse en la RED de prestadores de éstos servicios. Para nosotros es un orgullo ser
                      los
                      primeros en brindar a nuestros usuarios, servicios innovadores en materia del cuidado de la salud,
                      siendo la
                      empresa líder en éste segmento utilizando el concepto de membresías de servicios médicos.</small>
                  </div>
                </v-timeline-item>
              </v-timeline>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NosotrosComponent',
  data() {
    return {
      tab: 0,
      visible: false
    };
  },
  mounted() {
    const el = this.$refs.sectionRoot?.$el || this.$refs.sectionRoot;
    if (!el || typeof IntersectionObserver === 'undefined') {
      this.visible = true;
      return;
    }

    this._observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible = true;
          this._observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    this._observer.observe(el);
  },
  beforeDestroy() {
    this._observer?.disconnect();
  }
};
</script>

<style scoped>
.nosotros-container {
  background: linear-gradient(180deg, #ffffff 0%, #f5f9fd 100%);
  border-radius: 24px;
}

.section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px 7px 12px;
  border-radius: 999px;
  background: #dceeff;
  color: #1b4f8c;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.section-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1b4f8c;
}

.header-title {
  font-size: clamp(1.6rem, 2.8vw, 2.2rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: #16233a;
}

.fade-slide-down {
  opacity: 0;
  transform: translateY(-24px);
}

.is-visible .fade-slide-down {
  animation: fadeSlideDown 0.8s ease forwards;
}

.is-visible .fade-slide-down:nth-of-type(2) {
  animation-delay: 0.12s;
}

@keyframes fadeSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nosotros-card {
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08) !important;
}

.tab-titles ::v-deep .v-tab {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.mision-quote {
  font-style: italic;
  line-height: 1.8;
}

.no-bullets {
  list-style: none;
  padding-left: 0;
}

.no-bullets li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.timeline-year {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 4px;
  color: #1b4f8c;
}

@media (prefers-reduced-motion: reduce) {
  .fade-slide-down {
    opacity: 1;
    transform: none;
    animation: none;
  }
}

@media (max-width: 600px) {
  .nosotros-container {
    border-radius: 18px;
  }
}
</style>